export default __webpack_public_path__ + "static/belknap_logo-997a296b6d71eadb397d7fdbdf5f59e3.jpeg";